/**
 * 컨텐츠 언어(ES `tL` 필드) 옵션 맵.
 *
 * `tL`은 포스트 본문에서 감지한 언어를 ISO 639-1 **소문자 2자리** 코드로 저장한다
 * (예: 'ko', 'en', 'ja'). `un`은 미상(unknown).
 *
 * 국가 필터(languageMap)와 별개의 네임스페이스다 — 국가는 대문자 국가코드(market),
 * 언어는 소문자 언어코드(tL)다. 정렬은 실제 데이터 분포(빈도) 기준.
 *
 * 필드 구조는 국가 옵션(code/name/ko/country)과 호환되도록 맞췄다:
 *  - code : tL 값(소문자)
 *  - name : 표시용 라벨(한국어)
 *  - ko   : 한국어명(검색용, name과 동일)
 *  - en   : 영어명(검색용)
 */
export const contentLanguageMap = [
  { code: 'ko', name: '한국어', ko: '한국어', en: 'Korean' },
  { code: 'en', name: '영어', ko: '영어', en: 'English' },
  { code: 'ja', name: '일본어', ko: '일본어', en: 'Japanese' },
  { code: 'es', name: '스페인어', ko: '스페인어', en: 'Spanish' },
  { code: 'id', name: '인도네시아어', ko: '인도네시아어', en: 'Indonesian' },
  { code: 'pt', name: '포르투갈어', ko: '포르투갈어', en: 'Portuguese' },
  { code: 'vi', name: '베트남어', ko: '베트남어', en: 'Vietnamese' },
  { code: 'ar', name: '아랍어', ko: '아랍어', en: 'Arabic' },
  { code: 'th', name: '태국어', ko: '태국어', en: 'Thai' },
  { code: 'fr', name: '프랑스어', ko: '프랑스어', en: 'French' },
  { code: 'ms', name: '말레이어', ko: '말레이어', en: 'Malay' },
  { code: 'zh', name: '중국어', ko: '중국어', en: 'Chinese' },
  { code: 'ru', name: '러시아어', ko: '러시아어', en: 'Russian' },
  { code: 'it', name: '이탈리아어', ko: '이탈리아어', en: 'Italian' },
  { code: 'de', name: '독일어', ko: '독일어', en: 'German' },
  { code: 'tr', name: '튀르키예어', ko: '튀르키예어', en: 'Turkish' },
  { code: 'hi', name: '힌디어', ko: '힌디어', en: 'Hindi' },
  { code: 'tl', name: '타갈로그어', ko: '타갈로그어', en: 'Tagalog' },
  { code: 'bn', name: '벵골어', ko: '벵골어', en: 'Bengali' },
  { code: 'pl', name: '폴란드어', ko: '폴란드어', en: 'Polish' },
  { code: 'km', name: '크메르어', ko: '크메르어', en: 'Khmer' },
  { code: 'nl', name: '네덜란드어', ko: '네덜란드어', en: 'Dutch' },
  { code: 'my', name: '버마어', ko: '버마어', en: 'Burmese' },
  { code: 'fa', name: '페르시아어', ko: '페르시아어', en: 'Persian' },
  { code: 'ro', name: '루마니아어', ko: '루마니아어', en: 'Romanian' },
  { code: 'el', name: '그리스어', ko: '그리스어', en: 'Greek' },
  { code: 'uk', name: '우크라이나어', ko: '우크라이나어', en: 'Ukrainian' },
  { code: 'hr', name: '크로아티아어', ko: '크로아티아어', en: 'Croatian' },
  { code: 'sq', name: '알바니아어', ko: '알바니아어', en: 'Albanian' },
  { code: 'ur', name: '우르두어', ko: '우르두어', en: 'Urdu' },
  { code: 'sw', name: '스와힐리어', ko: '스와힐리어', en: 'Swahili' },
  { code: 'cs', name: '체코어', ko: '체코어', en: 'Czech' },
  { code: 'ta', name: '타밀어', ko: '타밀어', en: 'Tamil' },
  { code: 'hu', name: '헝가리어', ko: '헝가리어', en: 'Hungarian' },
  { code: 'bg', name: '불가리아어', ko: '불가리아어', en: 'Bulgarian' },
  { code: 'az', name: '아제르바이잔어', ko: '아제르바이잔어', en: 'Azerbaijani' },
  { code: 'te', name: '텔루구어', ko: '텔루구어', en: 'Telugu' },
  { code: 'sv', name: '스웨덴어', ko: '스웨덴어', en: 'Swedish' },
  { code: 'ne', name: '네팔어', ko: '네팔어', en: 'Nepali' },
  { code: 'mr', name: '마라티어', ko: '마라티어', en: 'Marathi' },
  { code: 'ml', name: '말라얄람어', ko: '말라얄람어', en: 'Malayalam' },
  { code: 'si', name: '싱할라어', ko: '싱할라어', en: 'Sinhala' },
  { code: 'sr', name: '세르비아어', ko: '세르비아어', en: 'Serbian' },
  { code: 'mn', name: '몽골어', ko: '몽골어', en: 'Mongolian' },
  { code: 'ku', name: '쿠르드어', ko: '쿠르드어', en: 'Kurdish' },
  { code: 'sk', name: '슬로바키아어', ko: '슬로바키아어', en: 'Slovak' },
  { code: 'da', name: '덴마크어', ko: '덴마크어', en: 'Danish' },
  { code: 'uz', name: '우즈베크어', ko: '우즈베크어', en: 'Uzbek' },
  { code: 'ka', name: '조지아어', ko: '조지아어', en: 'Georgian' },
  { code: 'fi', name: '핀란드어', ko: '핀란드어', en: 'Finnish' },
  { code: 'no', name: '노르웨이어', ko: '노르웨이어', en: 'Norwegian' },
  { code: 'he', name: '히브리어', ko: '히브리어', en: 'Hebrew' },
  { code: 'lt', name: '리투아니아어', ko: '리투아니아어', en: 'Lithuanian' },
  { code: 'lv', name: '라트비아어', ko: '라트비아어', en: 'Latvian' },
  { code: 'et', name: '에스토니아어', ko: '에스토니아어', en: 'Estonian' },
  { code: 'sl', name: '슬로베니아어', ko: '슬로베니아어', en: 'Slovenian' },
  { code: 'kk', name: '카자흐어', ko: '카자흐어', en: 'Kazakh' },
  { code: 'gu', name: '구자라트어', ko: '구자라트어', en: 'Gujarati' },
  { code: 'pa', name: '펀자브어', ko: '펀자브어', en: 'Punjabi' },
  { code: 'kn', name: '칸나다어', ko: '칸나다어', en: 'Kannada' },
  { code: 'un', name: '미상', ko: '미상', en: 'Unknown' },
];

